import styled, { css } from 'styled-components/macro';

import Layout from 'components/styled/Layout/Layout';
import {
  Toolbar,
  WhiteBlock,
} from 'components/utility/GenericComponent/GenericComponent';

const layoutStyles = css`
  ${Layout.MaxWidth} {
    margin: 0 auto;
    width: 100%;
    max-width: 100%;
    @media screen and (min-width: 60em) {
      width: 78.2%;
    }
  }
`;

export const ContentWrapper = styled('main')`
  position: relative;
  padding: ${({ theme }): string => theme.spacing.small};
  @media screen and (min-width: 40em) {
    padding: 1em 0;
  }

  ${layoutStyles}

  #opus-topic-filter-bar {
    margin: 0.5em auto;
    @media screen and (min-width: 40em) {
      width: 100%;
      margin: 1em auto;
    }
    @media screen and (min-width: 60em) {
      width: 78.2%;
    }
  }

  ${WhiteBlock} {
    @media screen and (max-width: 60em) {
      margin: 0;
      width: 100%;
    }
    @media screen and (min-width: 60em) {
      width: 78.2%;
      ${Layout.MaxWidth} {
        width: 100% !important;
      }
    }

    ${layoutStyles};
  }

  ${Toolbar} {
    padding: ${({ theme }): string => theme.spacing.small};
    @media screen and (min-width: 40em) {
      padding: ${({ theme }): string =>
        `${theme.spacing.xlarge} ${theme.spacing.xlarge} ${theme.spacing.small}`};
    }
  }
`;
